import React, { createContext, useContext } from 'react'
import { compose, withState, lifecycle } from 'recompose'
import isNode from 'detect-node'
import { OpenFeatureProvider } from '@openfeature/react-sdk'
import { initFeatureFlags } from 'utils/openFeature'

export const FeatureFlagsContext = createContext(false)

const FeatureFlagsProviderView = ({ isReady, children, identity }) => {
  if (isNode || typeof window === 'undefined' || !isReady) {
    return null
  }

  return (
    <FeatureFlagsContext.Provider value={isReady}>
      <OpenFeatureProvider>{children}</OpenFeatureProvider>
    </FeatureFlagsContext.Provider>
  )
}

export const FeatureFlagsProvider = compose(
  withState('isReady', 'setIsReady', false),

  lifecycle({
    componentDidMount() {
      if (isNode || typeof window === 'undefined') return

      let mounted = true

      initFeatureFlags(this.props.identity)
        .then(() => {
          if (mounted) this.props.setIsReady(true)
        })
        .catch((error) => {
          console.error('Failed to initialize feature flags', error)
          if (mounted) this.props.setIsReady(true) // Fallback gracefully
        })

      this.cleanup = () => {
        mounted = false
      }
    },

    componentWillUnmount() {
      if (this.cleanup) {
        this.cleanup()
      }
    },

    componentDidUpdate(prevProps) {
      if (
        prevProps.identity?.targetingKey !==
          this.props.identity?.targetingKey ||
        prevProps.identity?.userId !== this.props.identity?.userId
      ) {
        initFeatureFlags(this.props.identity)
      }
    },
  }),
)(FeatureFlagsProviderView)

export const useFeatureFlags = () => useContext(FeatureFlagsContext)
